export default __webpack_public_path__ + "static/media/img--design-5.a696fed3.jpg";